<template>
  <BittsModal
    :width="720"
    :show-primary-button="false"
    :show-secondary-button="false"
    :show-close-button="false"
    :use-mask-to-close="true"
    class="search-modal"
    @closed="emit('close')"
  >
    <div>
      <UniversalSearchMenu
        ref="universalSearchMenuRef"
        :expanded="false"
        :search-on-mount="true"
        :sidebar="true"
        class="search-modal__universal-search-menu"
        @item-selected="emit('close')"
      />
    </div>
  </BittsModal>
</template>

<script setup lang="ts">
import { BittsModal } from '@crossbeam/bitts';

import { onMounted, ref } from 'vue';

import UniversalSearchMenu from '@/components/navbar/UniversalSearchMenu.vue';

const emit = defineEmits<(e: 'close') => void>();

const universalSearchMenuRef = ref<InstanceType<
  typeof UniversalSearchMenu
> | null>(null);

onMounted(async () => {
  await universalSearchMenuRef.value?.focusSearchInput();
  await universalSearchMenuRef.value?.onSearch();
});
</script>

<style lang="pcss" scoped>
@reference "../../css/theme.css";
.o-bitts-modal.bitts-modal--primary:deep() dialog .o-bitts-modal__header,
.o-bitts-modal.bitts-modal--primary:deep() dialog .o-bitts-modal__footer {
  @apply hidden;
}
.o-bitts-modal.bitts-modal--primary:deep() .o-bitts-modal__content {
  @apply px-0 m-16 overflow-y-hidden;
}

.o-bitts-modal.bitts-modal--primary:deep() dialog {
  @apply pb-0 overflow-y-auto;
}

.o-bitts-modal.bitts-modal--primary:deep() .o-bitts-modal__content-wrapper,
.o-bitts-modal.bitts-modal--primary:deep() .o-bitts-modal__content--background {
  @apply flex-1;
}

.search-modal__universal-search-menu {
  @apply static max-w-full;
}

.search-modal__universal-search-menu:deep() .c-universal-search-menu__content {
  @apply border-none shadow-none z-0 max-w-full static h-[400px] flex flex-col justify-center;
}

.search-modal__universal-search-menu:deep() .c-universal-search-results {
  @apply p-0 overflow-y-auto flex-1 h-[400px];
}

.search-modal__universal-search-menu:deep()
  span.c-bitts-input__input.ant-input-affix-wrapper:not(
    .ant-input-affix-wrapper-disabled,
    .disabled,
    .danger,
    .success
  ) {
  @apply outline-none;
}

.search-modal__universal-search-menu:deep()
  span.c-bitts-input__input.ant-input-affix-wrapper:not(
    .ant-input-affix-wrapper-disabled,
    .disabled,
    .danger,
    .success
  ):hover {
  @apply outline-none border-2;
  border-right-width: 2px !important;
}
</style>
